import { format } from "date-fns";
import { useTranslation } from "react-i18next";

/**
 * Hook that formats a date using the current locale and i18n translations
 * Returns a formatted date string in the format "d month year" (e.g. "1 january 2024")
 */
export const useFormattedDate = () => {
  const { t } = useTranslation();

  const formatDate = (
    date: Date | string,
    settings: {
      monthFormat?: "short" | "full";
      format?:
        | "monthYear"
        | "dayMonthYear"
        | "minutesHours"
        | "dayMonthYearMinutesHours";
    } = {},
  ) => {
    try {
      const dateObject = date instanceof Date ? date : new Date(date);
      const month = t(
        `dates.months.${settings?.monthFormat ?? "full"}.${format(dateObject, "MMM").toLowerCase()}`,
      );

      if (settings?.format === "monthYear") {
        return `${month} ${dateObject.getFullYear()}`;
      }
      if (settings?.format === "minutesHours") {
        return format(dateObject, "HH:mm");
      }
      if (settings?.format === "dayMonthYearMinutesHours") {
        return `${format(dateObject, "d")} ${month.toLowerCase()} ${dateObject.getFullYear()} ${format(dateObject, "HH:mm")}`;
      }

      return `${format(dateObject, "d")} ${month.toLowerCase()} ${dateObject.getFullYear()}`;
    } catch (error) {
      console.warn(`Failed to format date "${date}"`, error);
      return "";
    }
  };

  return { formatDate };
};
